import { FormProvider as RHFFormProvider } from 'react-hook-form';
import type {
  UseFormReturn,
  FieldValues,
  SubmitErrorHandler,
} from 'react-hook-form';
import type { SxProps, Theme } from '@mui/material';
import { Box } from '@mui/material';

interface FormProviderProps<T extends FieldValues> {
  methods: UseFormReturn<T>;
  onSubmit: (data: T) => void;
  onInvalid?: SubmitErrorHandler<T>;
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

const FormProvider = <T extends FieldValues>({
  methods,
  onSubmit,
  onInvalid,
  children,
  ...boxProps
}: FormProviderProps<T>) => {
  return (
    <RHFFormProvider {...methods}>
      <Box
        component="form"
        noValidate
        onSubmit={methods.handleSubmit(onSubmit, onInvalid)}
        {...boxProps}
      >
        {children}
      </Box>
    </RHFFormProvider>
  );
};

export default FormProvider;
